<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof15">
<p class="tit"><em class="italic">Officer Literacy by Army Branches</em></p>
<p class="centerImage"><img alt="image" id="imgfr9" src="images/imgfr9.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof15.vue?5995af11